import { blendedAddonPrice } from 'default/addon-pricing';

$(document).on("turbo:load", function() {

  // Addon selector handling
  if ($(".js-addon-selector").length) {
    $(".js-addon-selector").each(function() {
      const $selector = $(this);
      const baseIdentities = parseInt($selector.data("base-identities"));
      const addonIncrement = parseInt($selector.data("addon-increment"));
      const addonMonthlyPrice = parseFloat($selector.data("addon-monthly-price"));
      const addonYearlyPrice = parseFloat($selector.data("addon-yearly-price"));
      const addonCode = $selector.data("addon-code");
      const initialUnits = parseInt($selector.data("initial-units")) || 0;
      const freeUnits = parseInt($selector.data("free-units")) || 0;
      let currentUnits = initialUnits;

      const discountEligible = $selector.data("discount-eligible") === true || $selector.data("discount-eligible") === "true";
      const fullPriceCapUnits = parseInt($selector.data("full-price-cap-units")) || 0;
      const addonDiscountedMonthlyPrice = parseFloat($selector.data("addon-discounted-monthly-price"));
      const addonDiscountedYearlyPrice = parseFloat($selector.data("addon-discounted-yearly-price"));

      function addonPriceForUnits(units, fullPrice, discountedPrice) {
        return blendedAddonPrice({ units: Math.max(0, units - freeUnits), fullPrice, discountedPrice, discountEligible, fullPriceCapUnits });
      }

      const $value = $selector.find(".js-addon-value");
      const $increaseBtn = $selector.find(".js-addon-increase");
      const $decreaseBtn = $selector.find(".js-addon-decrease");

      function updateDisplay() {
        const totalIdentities = baseIdentities + (currentUnits * addonIncrement);
        $value.text(totalIdentities);

        // Disable decrease button if at 0
        $decreaseBtn.prop("disabled", currentUnits === 0);

        // Store addon selection for subscription builder
        if (currentUnits > 0) {
          $selector.data("addon-units", currentUnits);
        } else {
          $selector.removeData("addon-units");
        }

        // Check if addon count changed from initial state
        const addonChanged = currentUnits !== initialUnits;

        // Trigger custom event for other parts of the app to listen to
        $(document).trigger("addon:changed", {
          addonCode: addonCode,
          units: currentUnits,
          baseIdentities: baseIdentities,
          totalIdentities: totalIdentities,
          monthlyPrice: addonPriceForUnits(currentUnits, addonMonthlyPrice, addonDiscountedMonthlyPrice),
          yearlyPrice: addonPriceForUnits(currentUnits, addonYearlyPrice, addonDiscountedYearlyPrice),
          changed: addonChanged,
          initialUnits: initialUnits
        });
      }

      $increaseBtn.on("click", function() {
        currentUnits++;
        updateDisplay();
      });

      $decreaseBtn.on("click", function() {
        if (currentUnits > 0) {
          currentUnits--;
          updateDisplay();
        }
      });

      setTimeout(updateDisplay, 0);
    });

    // Listen for addon changes and update pricing display
    $(document).on("addon:changed", function(e, data) {
      const planCode = $(".js-addon-selector").data("plan-code");

      const $yearlyToggle = $(".toggle-option-yearly");
      const isYearly = $yearlyToggle.length === 0 || $yearlyToggle.hasClass("selected");

      const $selectorForPlan = $(`.js-addon-selector[data-plan-code="${planCode}"]`);
      const requiredIdentities = parseInt($selectorForPlan.data("required-identities"), 10);
      if (!isNaN(requiredIdentities)) {
        const meetsRequirement = data.totalIdentities >= requiredIdentities;
        $(`.choose-plan[data-code="${planCode}"]`).each(function() {
          const $cta = $(this);
          $cta.toggleClass("disabled", !meetsRequirement);

          if (!meetsRequirement && $cta.attr("data-pico-action")) {
            $cta.attr("data-pico-action-disabled", $cta.attr("data-pico-action")).removeAttr("data-pico-action");
          } else if (meetsRequirement && $cta.attr("data-pico-action-disabled")) {
            $cta.attr("data-pico-action", $cta.attr("data-pico-action-disabled")).removeAttr("data-pico-action-disabled");
          }
        });
      }

      // Find the price elements for this plan
      const $priceValue = $(`.price-value[data-plan-code="${planCode}"]`);
      const $annualTotal = $(`.js-annual-total[data-plan-code="${planCode}"]`);

      if ($priceValue.length) {
        const baseMonthlyPrice = parseFloat($priceValue.data("base-monthly-price"));
        const baseYearlyPrice = parseFloat($priceValue.data("base-yearly-price"));

        // Calculate new prices with addons
        const newMonthlyPrice = baseMonthlyPrice + data.monthlyPrice;
        const newYearlyPrice = baseYearlyPrice + data.yearlyPrice;

        const yearlyPerMonth = "$" + Math.round(newYearlyPrice / 12.0);
        const monthlyPerMonth = "$" + Math.round(newMonthlyPrice);
        $priceValue
          .attr("data-yearly-price-per-month", yearlyPerMonth).data("yearly-price-per-month", yearlyPerMonth)
          .attr("data-monthly-price-per-month", monthlyPerMonth).data("monthly-price-per-month", monthlyPerMonth)
          .text(isYearly ? yearlyPerMonth : monthlyPerMonth);

        if ($annualTotal.length) {
          $annualTotal.text("$" + Math.round(newYearlyPrice).toLocaleString() + " total a year");
        }
      }

      // Handle "Current Plan" transformation when addons change
      // Find the selection row column for this plan
      const $selectionRowColumn = $(`.plan-selection-row td[data-plan-code="${planCode}"]`);
      const $currentPlanText = $selectionRowColumn.find(".current-plan-text");
      const $updateButton = $selectionRowColumn.find(".js-update-with-addons-btn");

      if (data.changed) {
        // Addon count changed - show update button instead of "Current Plan"
        $currentPlanText.hide();

        if ($updateButton.length === 0) {
          // Create update button if doesn't exist
          const billingMode = isYearly ? "yearly" : "monthly";
          const $newButton = $(`
            <a href="#"
               class="button small js-update-with-addons-btn js-open-addon-modal"
               data-toggle="modal"
               data-target="#addon-update-modal"
               data-code="${planCode}"
               data-addon-code="${data.addonCode}"
               data-addon-units="${data.units}"
               data-show-when="${billingMode}"
               data-pico-action="addon_updated"
               data-pico-info='{"plan_code":"${planCode}","plan_periodicity":"${billingMode}"}'>
              Update Plan
            </a>
          `);
          $currentPlanText.after($newButton);
        } else {
          // Update existing button with new units
          const billingMode = isYearly ? "yearly" : "monthly";
          $updateButton.attr("data-addon-units", data.units);
          $updateButton.attr("data-pico-info", JSON.stringify({plan_code: planCode, plan_periodicity: billingMode}));
          $updateButton.show();
        }
      } else {
        // Addon count reverted to initial - show "Current Plan" again
        $currentPlanText.show();
        $updateButton.hide();
      }
    });

    // When user clicks a plan selection button, append addon data to URL if present
    $(document).on("click", ".choose-plan", function(e) {
      const $btn = $(this);

      if ($btn.hasClass("disabled")) {
        e.preventDefault();
        return;
      }

      // Skip if this is the addon update button
      if ($btn.hasClass("js-update-with-addons-btn")) {
        return;
      }

      const planCode = $btn.data("code");

      // Check if this plan has an addon selector
      const $addonSelector = $(`.js-addon-selector[data-plan-code="${planCode}"]`);

      if ($addonSelector.length > 0) {
        const addonUnits = $addonSelector.data("addon-units");
        const addonCode = $addonSelector.data("addon-code");

        if (addonUnits && addonUnits > 0) {
          // Prevent default navigation
          e.preventDefault();

          // Get current URL from button's href
          const currentHref = $btn.attr("href");

          // Add addon parameter
          const separator = currentHref.includes("?") ? "&" : "?";
          const newHref = `${currentHref}${separator}addons[${addonCode}]=${addonUnits}`;

          // Navigate to new URL
          window.location.href = newHref;
        }
      }
    });

    // Handle "Update Plan" button click for addon changes on current subscription
    // Opens #addon-update-modal directly via data-toggle="modal"
  }

  if ((".js-public-pricing-tabs").length) {
    $(".toggle-option[data-show='yearly']").click(function() {
      if ($(this).hasClass("active")) return;

      $(".toggle-option[data-show='monthly']").removeClass("active");
      $(this).addClass("active");

      $(this).closest(".pricing-container").find(".price[data-show='monthly']").addClass("hidden");
      $(this).closest(".pricing-container").find(".price[data-show='yearly']").removeClass("hidden");
    });

    $(".toggle-option[data-show='monthly']").click(function() {
      if ($(this).hasClass("active")) return;

      $(this).addClass("active");
      $(".toggle-option[data-show='yearly']").removeClass("active");

      $(this).closest(".pricing-container").find(".price[data-show='yearly']").addClass("hidden");
      $(this).closest(".pricing-container").find(".price[data-show='monthly']").removeClass("hidden");
    });
  }

  if ($(".public-plan-comparison-table").length) {
    $(".public-plan-comparison-table .plan-card .title").click(function() {
      if (!$(".card-toggle:visible").length) return;

      $(this).closest(".plan-card").toggleClass("show-more");
    });
  }

  if ($(".pricing-features-table").length) {
    $(".pricing-features-table .accordion .accordion-heading").click(function() {
      $(this).closest(".accordion").toggleClass("active");
    });
  }

  if ((".js-toggle-quick-pricing").length) {
    $(".js-toggle-quick-pricing").click(function() {
      const yearly_toggle = $(".toggle-option-yearly");

      // Toggle the pill box month -> year selection
      yearly_toggle.toggleClass("selected");
      $(".toggle-option-monthly").toggleClass("selected");

      // Update SVGs
      $(".js-svg-path").toggleClass("svg-monthly-path");
      $(".js-svg-circle-focus").toggleClass("svg-price-circle-blob-monthly");
      $(".emphasis").toggleClass("monthly");
      $(".js-button-teams").toggleClass("monthly");

      // Hide and show annual totals
      $(".js-annual-total").toggle();

      // Update Pro or Focused Price option box
      if (yearly_toggle.hasClass('selected')) {
        $(".js-focus").addClass("focus-yearly").removeClass("focus-monthly");
        $(".fa-check").removeClass("monthly");
        $(".best-value").removeClass("monthly");
        $(".best-value > button").removeClass("monthly");
        $(".js-focus-column").removeClass("focus-monthly");
        $(".js-subheader-billing-period").text("billed yearly in USD");
        $("[data-show-when='yearly']").show();
        $("[data-show-when='monthly']").hide();

        $(".price-value-container .price-value").each(function(i, el){
          const price_value = $(el);
          price_value.text(price_value.data("yearly-price-per-month"));
        });

      } else {
        $(".js-focus").removeClass("focus-yearly").addClass("focus-monthly");
        $(".js-focus-column").addClass("focus-monthly");
        $(".fa-check").addClass("monthly");
        $(".best-value > button").addClass("monthly");
        $(".best-value").addClass("monthly");
        $(".js-subheader-billing-period").text("billed monthly in USD");
        $("[data-show-when='yearly']").hide();
        $("[data-show-when='monthly']").show();

        $(".price-value-container .price-value").each(function(i, el){
          const price_value = $(el);
          price_value.text(price_value.data("monthly-price-per-month"));
        });
      }
    });
  }
});
